export const getPreguntaById = (preguntas, idPregunta) => {
  const pregunta = Array.isArray(preguntas) && preguntas.length > 0
      && preguntas.find(pregunta => pregunta.id === idPregunta);
  return pregunta;
};

export const setPreguntaToEdit = (preguntas, pregunta) => {
    const preguntaFound = Array.isArray(preguntas) && pregunta;
  const preguntaToEdit = {
    ...preguntaFound,
    nombre: pregunta.nombre,
    id_academia: pregunta.id_academia,
  }
  return preguntaToEdit;
};

export const getPreguntasExamenesAcademiaById = (preguntasExamenesAcademia, id) => {
  const examen = Array.isArray(preguntasExamenesAcademia) && preguntasExamenesAcademia.length > 0
      && preguntasExamenesAcademia.find(examen => examen.idExamen === id);
  return examen;
};